import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "redux/axiosInterceptor";

const API_URL = process.env.REACT_APP_BASE_URL;

const initialState = [];

export const fetchAsyncAddClient = createAsyncThunk(
  "/fetchAsyncAddClient",
  async (data) => {
    try {
      const response = await axiosInstance.post('/client-project/create', data);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const fetchAsyncGetClient = createAsyncThunk(
  "/fetchAsyncGetClient",
  async () => {
    try {
      let url = `${API_URL}/client-project/get`;
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const fetchAsyncDeleteClient = createAsyncThunk(
  "/fetchAsyncDeleteClient",
  async (id) => {
    try {
      let url = `${API_URL}/client-project/delete/${id}`;
      const response = await axiosInstance.delete(url);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const fetchAsyncUpdateClient = createAsyncThunk(
  "/fetchAsyncUpdateClient",
  async (data) => {
    try {
      const response = await axiosInstance.post(`${API_URL}/client-project/update/${data.id}`, data.clientData);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);
export const fetchAsyncAddProject = createAsyncThunk(
  "/fetchAsyncAddProject",
  async (data) => {
    try {
      const response = await axiosInstance.post(`${API_URL}/client-project/add-project`, data);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);
export const fetchAsyncEditProject = createAsyncThunk(
  "/fetchAsyncEditProject",
  async (data) => {
    try {
      const response = await axiosInstance.post(`${API_URL}/client-project/edit-project`, data);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);
export const fetchAsyncDeleteProject = createAsyncThunk(
  "/fetchAsyncDeleteProject",
  async (data) => {
    try {
      const response = await axiosInstance.post(`${API_URL}/client-project/delete-project`, data);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);

export const fetchAsyncSearchClientProjectData = createAsyncThunk(
  "/fetchAsyncSearchClientProjectData",
  async (data) => {
    try {
      let url = `${API_URL}/client-project/search`;
      if (data.value) {
        url = url + `?search=${data.value}`;
      }
      if (data.startDate && data.endDate && data.value) {
        url = url + `&startDate=${data.startDate}&endDate=${data.endDate}`;
      }
      if (data.startDate && data.endDate && !data.value) {
        url = url + `?startDate=${data.startDate}&endDate=${data.endDate}`;
      }
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.msg);
    }
  }
);

export const fetchAsyncGetAllClients = createAsyncThunk(
  "/fetchAsyncGetAllClients",
  async () => {
    try {
      let url = `${API_URL}/client-project/get-clients`;
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);
export const fetchAsyncGetClientByID = createAsyncThunk(
  "/fetchAsyncGetClientByID",
  async (id) => {
    try {
      let url = `${API_URL}/client-project/get-client/${id}`;
      const response = await axiosInstance.get(url);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);
export const fetchAsyncGetClientGraphOverview = createAsyncThunk(
  "/fetchAsyncGetClientGraphOverview",
  async (data) => {
    try {
      let url = `${API_URL}/client-project/graph-overview`;
      const response = await axiosInstance.post(url,data);
      return response.data;
    } catch (error) {
      if (error.response?.status === 401) {
        throw new Error("Token Expire Please Login again!");
      } else {
        throw new Error(error.response.data.message);
      }
    }
  }
);
export const fetchAsyncGetClientExpenseOverview = createAsyncThunk(
  "/fetchAsyncGetClientExpenseOverview",
  async (data) => {
    try {
      let url = `${API_URL}/client-project/expense-overview`;
      const response = await axiosInstance.post(url,data);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);
export const fetchAsyncGetClientLedgerOverview = createAsyncThunk(
  "/fetchAsyncGetClientLedgerOverview",
  async (data) => {
    try {
      let url = `${API_URL}/client-project/ledger-overview`;
      const response = await axiosInstance.post(url,data);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);
export const fetchAsyncDeleteClientBank = createAsyncThunk(
  "/fetchAsyncDeleteClientBank",
  async (id,index) => {
    try {
      let url = `${API_URL}/client-project/delete-bank/${id}/${index}`;
      const response = await axiosInstance.delete(url);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);
export const fetchAsyncCheckClientGstIsUnique = createAsyncThunk(
  "/fetchAsyncCheckClientGstIsUnique",
  async (data) => {
    try {
      let url = `${API_URL}/client-project/check-gst`;
      const response = await axiosInstance.post(url,data);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);
export const fetchAsyncExportClient = 
  async (data) => {
    try {
      let url = `${API_URL}/client-project/export-client`;
      const response = await axiosInstance.post(url,data);
      return response;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
export const fetchAsyncGetClientTransactionLedger = createAsyncThunk(
  "/fetchAsyncGetClientTransactionLedger",
  async (data) => {
    try {
      let url = `${API_URL}/client-project/transaction-ledger`;
      const response = await axiosInstance.post(url,data);
      return response.data;
    } catch (error) {
      throw new Error(error.response.data.message);
    }
  }
);
const AllClientSlice = createSlice({
  name: "clientData",
  initialState,
  reducers: {},
  extraReducers: {
    [fetchAsyncGetClient.pending]: (state) => {},
    [fetchAsyncGetClient.fulfilled]: (state, { payload }) => {
      return payload;
    },
    [fetchAsyncSearchClientProjectData.pending]: (state) => {},
    [fetchAsyncSearchClientProjectData.fulfilled]: (state, { payload }) => {
      return payload;
    },
  },
});

export const getAllClient = (state) => state.clientData;

export default AllClientSlice.reducer;